import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var MathInTextIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9678 32.2314C44.5543 32.7998 44.569 33.7359 44.0005 34.3223L36.1027 42.4696C35.5343 43.056 34.5979 43.0707 34.0114 42.5024C33.4248 41.934 33.4102 40.9979 33.9786 40.4115L41.8764 32.2642C42.4449 31.6778 43.3812 31.6631 43.9678 32.2314Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0114 32.2314C34.5979 31.6631 35.5343 31.6778 36.1027 32.2642L44.0005 40.4115C44.569 40.9979 44.5543 41.934 43.9678 42.5024C43.3812 43.0707 42.4449 43.056 41.8764 42.4696L33.9786 34.3223C33.4102 33.7359 33.4248 32.7998 34.0114 32.2314Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9278 23.2466C29.1574 22.6955 29.696 22.3365 30.2931 22.3365H44.521C45.3378 22.3365 46 22.9985 46 23.8152C46 24.6318 45.3378 25.2938 44.521 25.2938H31.2792L23.7606 43.3399C23.5189 43.9199 22.937 44.2839 22.3095 44.2475C21.6821 44.2111 21.1462 43.7822 20.9734 43.1781L17.8083 32.1178C17.5836 31.3327 18.0381 30.5141 18.8234 30.2895C19.6088 30.0649 20.4275 30.5193 20.6522 31.3044L22.6549 38.3028L28.9278 23.2466Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.85898C2 4.24651 2.49663 3.75 3.10924 3.75H44.521C45.1336 3.75 45.6303 4.24651 45.6303 4.85898C45.6303 5.47145 45.1336 5.96796 44.521 5.96796H3.10924C2.49663 5.96796 2 5.47145 2 4.85898Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.3371C2 13.7246 2.49663 13.2281 3.10924 13.2281H44.521C45.1336 13.2281 45.6303 13.7246 45.6303 14.3371C45.6303 14.9495 45.1336 15.4461 44.521 15.4461H3.10924C2.49663 15.4461 2 14.9495 2 14.3371Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 33.2933C2 32.6808 2.49663 32.1843 3.10924 32.1843H11.4508C12.0634 32.1843 12.56 32.6808 12.56 33.2933C12.56 33.9057 12.0634 34.4022 11.4508 34.4022H3.10924C2.49663 34.4022 2 33.9057 2 33.2933Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 42.7713C2 42.1589 2.49663 41.6624 3.10924 41.6624H11.4508C12.0634 41.6624 12.56 42.1589 12.56 42.7713C12.56 43.3838 12.0634 43.8803 11.4508 43.8803H3.10924C2.49663 43.8803 2 43.3838 2 42.7713Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 23.8152C2 23.2027 2.49663 22.7062 3.10924 22.7062H19.2303C19.8429 22.7062 20.3395 23.2027 20.3395 23.8152C20.3395 24.4276 19.8429 24.9241 19.2303 24.9241H3.10924C2.49663 24.9241 2 24.4276 2 23.8152Z"
  }));
});
MathInTextIcon.displayName = 'MathInTextIcon';
MathInTextIcon.defaultProps = {
  'aria-label': 'MathInText'
};
export default MathInTextIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/MathInTextIcon/index.js
// module id = 1887
// module chunks = 12